// src/frontend_react/src/components/ui/EmptyState/EmptyState.js
import React from 'react';
import Stack from '../Stack/Stack';
import Icon from '../Icon/Icon';
import Typography from '../Typography/Typography';
import Button from '../Button/Button';
import { FiInbox } from 'react-icons/fi'; 
import styles from './EmptyState.module.css'; 

const EmptyState = ({
  icon,
  title,
  message,
  actionText,
  onAction,
}) => {
  const IconComponent = icon || FiInbox;

  return (
    <div className={styles.emptyStateWrapper}>
      <Stack spacing="md" alignItems="center" className={styles.contentStack}>
        <Icon as={IconComponent} size="h1" color="placeholder" />
        <Typography variant="h4" component="h3">{title}</Typography>
        <Typography color="secondary" className={styles.message}>{message}</Typography>
        {actionText && onAction && (
          <Button variant="primary" onClick={onAction} mt="md">
            {actionText}
          </Button>
        )}
      </Stack>
    </div>
  );
};

export default EmptyState;